<template>
  <section
    v-if="products"
    class=" container pt-3 mt-2 mt-sm-1 mb-sm-5 mb-4 home-products-Slder"
  >
    <div
      v-if="titleBox"
      class="title-box d-flex align-items-center justify-content-between"
    >
      <h3 class="font-weight-bold fontsize-xheavy text-pink-theme2">
        {{ titleBox }}
      </h3>
      <router-link
        :to="`/products?sort=${activeTabLink}`"
        class="text-white font-weight-bold bg-pink-theme2"
        >مشاهده بیشتر</router-link
      >
    </div>
    <div class="mt-5" :id="sliderId">
      <div class=" swiper-container" v-if="products">
        <div
          class="swiper-wrapper "
          v-if="
            products != '' &&
              !disabledSliders.includes('myProducts-slider-home')
          "
        >
          <template v-if="mainList.length">
            <div
              class="swiper-slide px-1 box-shaddow20"
              v-for="(product, index) in mainList"
              :key="index"
            >
              <Product :product="product"></Product>
            </div>
          </template>
          <template v-else>
            <div
              class="swiper-slide px-1 box-shaddow20"
              v-for="(product, index) in productList"
              :key="index"
            >
              <Product :product="product"></Product>
            </div>
          </template>
        </div>
      </div>
      <Loading v-else />
    </div>
  </section>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min";
import Product from "@/parts/Front/components/product/Product";
import Loading from "@/parts/Front/components/shared/Loading";

export default {
  name: "homeProductSlider",
  components: {
    Product,
    Loading,
  },
  data() {
    return {
      products: null,

      activeTabLink: "newest",
    };
  },
  inject: ["mediaQueries"],
  props: {
    typeSlider: {
      type: String,
      default: "new-products",
    },
    titleBox: {
      type: String,
      default: null,
    },
    sliderId: String,
    mainList: {
      type: Array,
      default: [],
    },
  },
  mounted() {
    this.setActiveProducts(this.typeSlider);
    this.initProductHomeSlider();
  },
  methods: {
    initProductHomeSlider(kill = false) {
      this.initSwiper(this.sliderId, kill, () => {
        new Swiper(`#${this.sliderId} .swiper-container`, {
          spaceBetween: 30,
          loop: false,
          speed: 500,
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },

          breakpoints: {
            250: {
              slidesPerView: 2,
              spaceBetween: 1,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1500: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
          },
        });
      });
    },
    async setActiveProducts(tab) {
      // this.activeTab = tab;
      this.products = null;
      let res = await this.$store.dispatch(
        "front/getIndexPageContent",
        this.typeSlider
      );
      this.products = res;
      this.activeTabLink =
        tab === "most-discounts" ? "most_discount" : "newest";
    },
  },
  computed: {
    productList() {
      return this.products;
    },
  },
  watch: {
    productList() {
      this.initProductHomeSlider();
    },
  },
};
</script>

<style scoped>
.home-products-Slder {
  margin-top: 60px !important;
}
.title-box {
  /* border-bottom: 0.0625rem solid #dadee4;*/
}
.title-box a {
  display: inline-block;
  width: fit-content;
  font-size: 14px;
  padding: 6px 18px;
  border-radius: 15px;
}
@media screen and (max-width: 500px) {
  .recommended-products-category a.fontsize-medium {
    font-size: 13px !important;
  }
  .title-box h3 {
    font-size: 18px !important;
  }
  .title-box a {
    font-size: 13px;
  }
  .home-products-Slder {
    margin-top: 40px !important;
  }
}
</style>
